import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Breadcrumbs from '../navigation/Breadcrumbs';
import { buildServiceBreadcrumbs } from '../navigation/breadcrumbUtils';
import './DataScience.css';

const DataScience = () => {
  const location = useLocation();
  const servicesIndexView = location.state?.servicesIndexView;
  const backPath = servicesIndexView ? '/services' : '/';

  return (
    <div className="data-science-page-wrapper">
      <div className="data-science-page-container">
        <Breadcrumbs
          items={buildServiceBreadcrumbs('services', 'Data Science')}
        />

        <div className="data-science-back-link">
          <Link
            to={backPath}
            state={servicesIndexView ? { servicesIndexView } : undefined}
          >
            {servicesIndexView ? '\u2190 Back' : '\u2190 Back to Home'}
          </Link>
        </div>

        <div className="data-science-page-hero">
          <h1>Data Science Services</h1>
          <p>
            BlackRoth delivers advanced Data Science services that help
            organizations extract meaningful insights from data, improve
            decision-making, and drive measurable business outcomes.
          </p>
        </div>

        <section className="data-science-page-section">
          <h2>Overview</h2>
          <p>
            Data Science combines statistical analysis, data engineering,
            and analytical modeling to uncover patterns and trends in data.
            BlackRoth enables businesses to turn raw data into strategic
            intelligence through structured, scalable data solutions.
          </p>
        </section>

        <section className="data-science-page-section">
          <h2>Core Capabilities</h2>
          <p>
            Our Data Science solutions focus on data accuracy, analytical
            depth, and business relevance, ensuring insights that can be
            confidently used for operational and strategic decisions.
          </p>
        </section>

        <section className="data-science-page-section">
          <h2>Services We Offer</h2>
          <ul className="data-science-service-list">
            <li>Data Exploration & Statistical Analysis</li>
            <li>Data Cleaning & Feature Engineering</li>
            <li>Predictive & Descriptive Analytics</li>
            <li>Business Intelligence & Reporting</li>
            <li>Data Visualization & Insights</li>
            <li>Big Data Analytics</li>
            <li>Data Pipeline Design & Optimization</li>
            <li>Analytics Integration & Automation</li>
          </ul>
        </section>

        <section className="data-science-page-section">
          <h2>Industry Use Cases</h2>
          <p>
            BlackRoth's Data Science services support industries such as
            finance, healthcare, retail, manufacturing, logistics, and
            technology by enabling data-driven strategies and operational
            efficiency.
          </p>
        </section>

        <section className="data-science-page-section">
          <h2>Technology Stack</h2>
          <p>
            We work with modern data technologies including Python, R, SQL,
            data warehouses, cloud analytics platforms, and scalable data
            processing frameworks.
          </p>
        </section>

        <section className="data-science-page-section">
          <h2>Data Governance & Quality</h2>
          <p>
            BlackRoth ensures data integrity, consistency, and governance
            through validated data pipelines, access controls, and best
            practices for enterprise data management.
          </p>
        </section>
      </div>
    </div>
  );
};

export default DataScience;

